import Flickity from 'flickity';
import $ from 'jquery';

$(document).ready(function() {
  const $slider = $('.m-main-slider .slider');
  const autoplayOpt = $slider.data("autoplaysld");

  //
  $slider.each(function() {
    const $thisSlider = $(this);
    const slider = $thisSlider[0];

    //
    const flkty = new Flickity(slider, {
      cellSelector: '.slide',
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      autoPlay: autoplayOpt && autoplayOpt === true ? 5000 : false
    });

    //
    const texts = slider.querySelectorAll('.slide-text');
    const docStyle = document.documentElement.style;
    const transformProp = typeof docStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
    const videos = slider.querySelectorAll('video');

    //
    flkty.on('scroll', function () {
    	flkty.slides.forEach(function (slide, i) {
    		const text = texts[i];
    		const x = ( slide.target + flkty.x ) * 1/8;

    		text.style[transformProp] = 'translateX(' + x + 'px)';
    	});
    });

    flkty.on('select', function () {
      videos.forEach(function (video) {
        video.pause();
    	});
    });

  });
});



// WEBPACK FOOTER //
// ./app/ui/modules/main-slider/index.js